import { AstmLoginComponent } from '../../../pages/login';
import { HcnLoginComponent } from '../../../pages/login';
import { IeeeLoginComponent } from '../../../pages/login';
import { IeeecsLoginComponent } from '../../../pages/login';
import { IjcLoginComponent } from '../../../pages/login';
import { IopLoginComponent } from '../../../pages/login';
import { NpgLoginComponent } from '../../../pages/login';
import { PalLoginComponent } from '../../../pages/login';
import { PalconnectLoginComponent } from '../../../pages/login';
import { RcniLoginComponent } from '../../../pages/login';
import { RscLoginComponent } from '../../../pages/login';
import { SprotocolsLoginComponent } from '../../../pages/login';
import { TglLoginComponent } from '../../../pages/login';
import { SmaterialsLoginComponent } from '../../../pages/login';
import { GenericLoginComponent } from '../../../pages/login';
import { SimageLoginComponent } from '../../../pages/login';
import { MmsLoginComponent } from '../../../pages/login';
// import { UcpLoginComponent } from '../../../pages/login';
// export const MYCLIENTS = [
//       'mit', 'ieee', 'php',
//       'ucp', 'iop', 'lib-serv',
//       'wtcox', 'generic', 'smaterial',
//       'simage', 'sprotocol', 'iop-science',
//       'ieeecs', 'npg', 'rsc',
//       'rcni', 'hcn',
//       'ijc', 'tgl',
//       'pal', 'palconnect', 'astm'
// ];
//  'sprotocols',   'iopscience'  common think and insight


export interface MYCLIENTSi {
      url: Array<string>;
      clientID: string;
      firstPage: string;
      project: 'think' | 'insight' | 'both';
      LicenseDenial: 'required' | 'null';
      component: any;

}


export const MYCLIENTS: Array<MYCLIENTSi> = [
      {
            url: ['ieee'],
            clientID: 'ieee',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'IeeeLoginComponent',
            LicenseDenial: 'required'
      }, {
            url: ['iop'],
            clientID: 'iop',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'IopLoginComponent',
            LicenseDenial: 'required'
      }, {
            url: ['smaterial'],
            clientID: 'smaterial',
            firstPage: 'dashboard',
            project: 'insight',
            component: 'SmaterialsLoginComponent',
            LicenseDenial: 'null'
      }, {
            url: ['simage'],
            clientID: 'simage',
            firstPage: 'dashboard',
            project: 'insight',
            component: 'SimageLoginComponent',
            LicenseDenial: 'null'
      }, {
            url: ['sprotocol'],
            clientID: 'springer',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'SprotocolsLoginComponent',
            LicenseDenial: 'required'
      },
      {
            url: ['iopscience'],
            clientID: 'iopscience',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'IopscienceLoginComponent',
            LicenseDenial: 'required'
      },
      {
            url: ['ieeecs'],
            clientID: 'ieeecs',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'IeeecsLoginComponent',
            LicenseDenial: 'null'
      }, {
            url: ['npg'],
            clientID: 'npg',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'NpgLoginComponent',
            LicenseDenial: 'required'
      }, {
            url: ['rsc'],
            clientID: 'rsc',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'RscLoginComponent',
            LicenseDenial: 'null'
      }, {
            url: ['mms'],
            clientID: 'mms',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'MmsLoginComponent',
            LicenseDenial: 'null'
      }, {
            url: ['rcni'],
            clientID: 'rcni',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'RcniLoginComponent',
            LicenseDenial: 'null'
      }, {
            url: ['hcn'],
            clientID: 'hcn',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'HcnLoginComponent',
            LicenseDenial: 'required'
      }, {
            url: ['ijc'],
            clientID: 'ijc',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'IjcLoginComponent',
            LicenseDenial: 'null'
      }, {
            url: ['tgl'],
            clientID: 'tgl',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'TglLoginComponent',
            LicenseDenial: 'null'
      }, {
            url: ['pal'],
            clientID: 'pal',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'PalLoginComponent',
            LicenseDenial: 'required'
      }, {
            url: ['palconnect'],
            clientID: 'palconnect',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'PalconnectLoginComponent',
            LicenseDenial: 'required'
      }, {
            url: ['astm'],
            clientID: 'astm',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'AstmLoginComponent',
            LicenseDenial: 'null'
      }, {
            url: ['insight'],
            clientID: 'insight',
            firstPage: 'insight-dashboard',
            project: 'insight',
            component: 'DemoLoginComponent',
            LicenseDenial: 'null'

      }
];





// WEBPACK FOOTER //
// ./src/app/core/Services/myClient/myClient.data.ts